import './combobox.scss';

class MultiSelect {
    constructor ($element) {
        this.$multiSelect = $element;
        this.$selectBox = this.$multiSelect.querySelector('[data-multiselect="select-box"]');
        this.$fakeOptionWrapper = this.$multiSelect.querySelector('[data-multiselect="fake-options"]');
        this.$fakeOptions = [];
        this.$selectedItems = this.$multiSelect.querySelector('[data-multiselect="selected-items"]');
        this.$selectedValues = [];
        this.multibleOptions = this.$multiSelect.dataset.multibleOptions;
        this.disabledState = this.$multiSelect.dataset.disabledState;
        this.hideSelected = this.$multiSelect.dataset.hideSelected;
        this.autoCloseOnChange = this.$multiSelect.dataset.autoCloseOnChange;
    }

    initialize () {
        this.$multiSelect.setAttribute('data-multiselect-init', 'true');
        this.$fakeOptions = this.$fakeOptionWrapper.querySelectorAll('[data-multiselect="fake-option"]');

        this.$selectBox.onclick = () => {
            if (this.disabledState === 'false') {
                this.toggleOptions();
            }
        };

        this.$selectBox.addEventListener('keydown', (event) => {
            if (event.code === 'Space' || event.code === 'Enter') {
                event.preventDefault();

                if (this.disabledState === 'false') {
                    this.toggleOptions();
                }
            }

            if (event.code === 'Escape') {
                event.preventDefault();
                this.toggleOptions();
            }
        });

        this.$fakeOptions.forEach($fakeOption => {
            const $checkbox = $fakeOption.querySelector('input[type="radio"]');

            $fakeOption.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    $checkbox.parentElement.click();
                    this.updateSelectedItems($checkbox);

                    if (this.multibleOptions === 'false') {
                        this.clearOptionsExceptCurrent($checkbox);
                    }
                }
            });

            $checkbox.addEventListener('change', () => {
                this.updateSelectedItems($checkbox);

                if (this.multibleOptions === 'false') {
                    this.clearOptionsExceptCurrent($checkbox);
                }
            });
        });

        document.addEventListener('click', (e) => {
            this.handleOutsideClick(e);
        });

        document.addEventListener('keydown', (event) => {
            if (event.code === 'Tab' || event.code === 'Tabs') {
                this.handleOutsideClick(event);
            }
        });

        window.addEventListener('select.options.rerender', () => {
            this.$fakeOptions = [];
            this.$fakeOptions = this.$fakeOptionWrapper.querySelectorAll('[data-multiselect="fake-option"]');
        });

        this.initCheckForSelected();
    }

    initCheckForSelected () {
        this.$fakeOptions.forEach($fakeOption => {
            const $checkbox = $fakeOption.querySelector('input[type="radio"]');
            if ($checkbox.checked) {
                this.updateSelectedItems($checkbox, false);
            }
        });
    }

    autoClose () {
        this.$fakeOptionWrapper.setAttribute('data-aria-hidden', true);
        this.$multiSelect.setAttribute('data-multiselect-active', false);
        this.$selectBox.setAttribute('aria-label', this.$selectBox.dataset.ariaClosed);
    }

    clearOptionsExceptCurrent ($currentCheckbox) {
        this.$fakeOptions.forEach($fakeOption => {
            const $checkbox = $fakeOption.querySelector('input[type="radio"]');
            if ($checkbox !== $currentCheckbox) {
                $checkbox.checked = false;
                this.updateSelectedItems($checkbox);
            }
        });
    }

    toggleOptions () {
        const expanded = this.$multiSelect.getAttribute('data-multiselect-active') === 'true';
        this.$fakeOptionWrapper.setAttribute('data-aria-hidden', expanded);
        this.$multiSelect.setAttribute('data-multiselect-active', !expanded);

        if (!expanded) {
            this.$selectBox.setAttribute('aria-label', this.$selectBox.dataset.ariaOpen);
        } else {
            this.$selectBox.setAttribute('aria-label', this.$selectBox.dataset.ariaClosed);
        }
    }

    updateSelectedItems ($checkbox) {
        const $checkboxValue = $checkbox.value;
        const $checkboxLabel = $checkbox.parentNode.textContent.trim();
        const $selectOption = this.$multiSelect.querySelector(`option[value="${$checkboxValue}"]`);

        if ($checkbox.checked) {
            $selectOption.selected = true;
            this.$selectedValues.push($checkboxLabel);
            $checkbox.parentNode.classList.add('select-box__fake-option--active');
            $checkbox.parentNode.setAttribute('aria-checked', true);
            $checkbox.setAttribute('checked', 'checked');
        } else {
            $selectOption.selected = false;
            this.$selectedValues = this.$selectedValues.filter(value => value !== $checkboxLabel);
            $checkbox.parentNode.classList.remove('select-box__fake-option--active');
            $checkbox.parentNode.setAttribute('aria-checked', false);
            $checkbox.removeAttribute('checked');
        }

        if (this.hideSelected === 'false') {
            this.$selectedItems.textContent = this.$selectedValues.join(', ') || this.$selectedItems.dataset.placeholder;
        }

        if (this.autoCloseOnChange === 'true') {
            this.autoClose();
        }
    }

    handleOutsideClick (e) {
        if (e.target !== this.$multiSelect && e.target !== this.$selectBox && !e.target.classList.contains('select-box__fake-option')) {
            this.autoClose();
        }
    }
}

export { MultiSelect };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$multiSelect = $context.querySelectorAll('[data-multiselect="root"]');

        for (let i = 0; i < $$multiSelect.length; i++) {
            const multiSelect = new MultiSelect($$multiSelect[i]);
            multiSelect.initialize();
        }
    }
});

window.addEventListener('init.combobox.model.finder', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$multiSelect = $context.querySelectorAll('[data-multiselect="root"]:not([data-multiselect-init="true"])');

        for (let i = 0; i < $$multiSelect.length; i++) {
            const multiSelect = new MultiSelect($$multiSelect[i]);
            multiSelect.initialize();
            console.log('init');
        }
    }
});
